import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import BasePage from '@ts-core/pages/BasePage';

import BackButton from '@ts-core/components/BackButton';

import MultipleChoiceExercisePreviewPage from 'modules/multipleChoiceExercises/pages/MultipleChoiceExercisePreviewPage';
import FillInTheBlanksExercisePreviewPage from 'modules/fillInTheBlanksExercises/pages/FillInTheBlanksExercisePreviewPage';

const ExercisePreviewEntryPage = () => {
  const { type } = useParams<{ courseId: string; subjectId: string; type: string; exerciseId: string }>();
  const { search } = useLocation();
  const { from, title } = queryString.parse(search) || {};

  function renderExercisePage() {
    if (type === 'FillInTheBlanksExercise') {
      return <FillInTheBlanksExercisePreviewPage />;
    }
    return <MultipleChoiceExercisePreviewPage />;
  }

  return (
    <BasePage>
      {from && <BackButton subtitle={title} href={from as string} />}
      {renderExercisePage()}
    </BasePage>
  );
};

export default ExercisePreviewEntryPage;
